<template>
  <div>
    <v-dialog v-model="isUploading" width="500px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Upload document icon</span>
          <v-btn text icon dark @click="isUploading = false" title="Upload Icon">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <upload-icon @uploaded="handleUpload" :upload-url="uploadUrl" />
        </v-container>
      </v-card>
    </v-dialog>
    <span>
      <v-avatar v-if="icon">
        <img :src="icon" />
      </v-avatar>
      <span v-else>N/A</span>
      <v-btn icon text @click="isUploading = true" title="Upload Icon">
        <v-icon>mdi-image-plus</v-icon>
      </v-btn>
    </span>
  </div>
</template>
<script>
import UploadIcon from "@/components/documents/upload";
export default {
  props: {
    currency: {
      type: Object,
      required: true,
    },
  },
  components: { UploadIcon },
  data() {
    return {
      isUploading: false,
      icon: this.currency.icon,
    };
  },
  computed: {
    uploadUrl() {
      return `api/v1/cryptoCurrencies/${this.currency.id}/uploadIcon`;
    },
  },
  methods: {
    handleUpload({ icon }) {
      this.isUploading = false;
      this.icon = icon;
    },
  },
};
</script>
